import jQuery from 'jquery';
import rpBreakpoints, { breakpointCodes } from 'rp-mq-breakpoints';

const defaultConfig = {};

export default class PdfDropDown {
    constructor(dropdownSettingsConfig) {
        this.config = jQuery.extend(true, defaultConfig, dropdownSettingsConfig);
        this.dropDownSelector = '.js-RC-pdfDropDown';
        this.tableTimeSelector = '.js-RC-pdfPopoverTableTime';
        this.popOverTitleSelector = '.js-RC-pdfPopoverTitle';
        this.popOverTableRowSelector = '.js-RC-pdfPopoverTableRow';
        // TODO: refactor test, you should not check plugins due to test purposes (JIRA: PC-4560)
        const dropDown = jQuery(this.dropDownSelector);

        if (dropDown && dropDown.rpSelect) {
            dropDown.rpSelect();
            this.updateBreakpointsState(rpBreakpoints.current().code);
            this.bindEvents();
        }
    }

    bindEvents() {
        jQuery(window).on('rpBreakpointsSwitch', this.onSwitchBreakpointsHandler.bind(this));
        jQuery(this.dropDownSelector).on('opened.rp.selectDropdown', this.updateRaceTimeTitleUI.bind(this));
        jQuery(this.dropDownSelector).on('closed.rp.selectDropdown', this.updateRaceTimeTitleUI.bind(this));
        jQuery(this.dropDownSelector).on('change', this.updateOnChangeEvent.bind(this));
    }

    onSwitchBreakpointsHandler(event) {
        this.updateBreakpointsState(event.detail.breakpoint.code);
    }

    updateBreakpointsState(breakpoint) {
        const isBigBreakpoint = [
            breakpointCodes.MEDIUM,
            breakpointCodes.WIDE,
            breakpointCodes.EXTRA_WIDE
        ].includes(breakpoint);

        if (isBigBreakpoint) {
            jQuery(this.tableTimeSelector).css('display', 'block');
        } else {
            jQuery(this.tableTimeSelector).css('display', 'none');
        }
    }

    updateRaceTimeTitleUI(event) {
        jQuery(this.popOverTitleSelector).removeClass('RC-pdfPopover__select_active');
        if (event && event.type === 'opened') {
            jQuery(this.popOverTitleSelector).addClass('RC-pdfPopover__select_active');
        }
    }

    updateOnChangeEvent(event) {
        const time = event.currentTarget.value;
        jQuery(this.popOverTableRowSelector).removeClass('RC-pdfPopover__tableRow_selected');
        jQuery(`${this.popOverTableRowSelector}[data-time="${time}"]`).addClass('RC-pdfPopover__tableRow_selected');
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/pdfDropdown.js